<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-message-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4c1.105 0 2 .914 2 2.042V34.98c0 1.128-.895 2.042-2 2.042H32l-6.586 6.38a1.97 1.97 0 01-2.828 0L16 37.022H6c-1.105 0-2-.914-2-2.042V6.042C4 4.914 4.895 4 6 4h36zm-2 4H8v25.02h9.657L24 39l6.343-5.98H40V8zM27 22a1 1 0 011 1v2a1 1 0 01-1 1H13a1 1 0 01-1-1v-2a1 1 0 011-1h14zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H13a1 1 0 01-1-1v-2a1 1 0 011-1h22z"/></svg>
</template>
<script>

export default {
  name: 'IconMessageAlt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
